import { useContext } from "react";
import { useAuth } from "../../hooks/useAuth";
import { hasAnyGuidedTour } from "./guidedTours";
import { TourContext } from "./tourContext";

/**
 * Whether the sidebar should offer the Guided tours list.
 *
 * False until the tour config has loaded, so the item never shows and then vanishes, and false when
 * tours are unavailable ("disabled") or outside a `TourProvider`. While tours are switched off for
 * everyone, the API serves a coach no tours at all, which is what hides the item for them.
 */
export const useHasGuidedTours = (): boolean => {
  const context = useContext(TourContext);
  const { user } = useAuth();
  if (!context || context.status !== "ready") return false;
  return hasAnyGuidedTour(user?.profile, context.hasPageTour);
};
